// eslint-disable-next-line import/prefer-default-export
export const LinkProperty = {
  ClassName: 'className',
  WrapperClassName: 'wrapperClassName',
  HasChevron: 'hasChevron',
  RedirectTo: 'redirectTo',
  ColorScheme: 'colorScheme',
  IsUnderlined: 'isUnderlined',
};
